import { Component, inject } from '@angular/core';

import { ButtonModule, DialogRef, IconModule } from '@pinup-teams/common';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '@fb/environments';

import { AiChatFormDialog } from '../ai-chat-form/ai-chat-form.dialog';
import { SupportFormDialog } from '../support-form/support-form.dialog';
import { TranslateInPipe } from '../../pipes/translate-in.pipe';
import { SupportCategories } from '../../models';

@Component({
  standalone: true,
  selector: 'pu-finance-dialog',
  templateUrl: './finance-dialog.component.html',
  styleUrl: './finance-dialog.component.scss',
  imports: [ButtonModule, IconModule, TranslateModule, TranslateInPipe],
  providers: [AiChatFormDialog, SupportFormDialog],
})
export class FinanceDialogComponent {
  #dialogRef = inject(DialogRef);
  #aiChatFormDialog = inject(AiChatFormDialog);
  #supportFormDialog = inject(SupportFormDialog);

  categories = SupportCategories;

  assetsUrl = environment.assetsUrl;
  financeConfluenceLink = environment.financeConfluenceLink;
  aiChatButtonIcon = `${environment.shortName}-ai-chat-button`;

  openSupport() {
    this.close();
    this.#supportFormDialog.open(this.categories.finance);
  }

  openChat() {
    this.close();
    this.#aiChatFormDialog.open();
  }

  close(): void {
    this.#dialogRef.close();
  }
}
